import { ChangeDetectionStrategy, ChangeDetectorRef, Component, computed, ElementRef, EventEmitter, Input, OnInit, Output, signal, TemplateRef, ViewChild, WritableSignal } from '@angular/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { UnsavedChangesDialogComponent } from 'src/app/components/dialogs/unsavedChangesDialog/unsavedChangesDialog.component';
import { UserSelectedHeaderModel } from '../../../../model/firm/user-selected-header.model';
import { ApiService } from '../../../../services/api.service';
import { modules } from '../../../../services/app-config';
import { EncodingService } from '../../../../services/encoding.service';
import { FileService } from '../../../../services/file-service';
import { FirmService } from '../../../../services/firm.service';
import { SharedService } from '../../../shared/shared.service';
import { finalize, of } from 'rxjs';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { DragDropDirective } from 'src/app/helpers/drag-and-drop-upload';

@Component({
  selector: 'app-headers',
  templateUrl: './headers.component.html',
  styleUrls: ['./headers.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, MatButtonModule, MatListModule, MatSlideToggleModule, MatCheckboxModule, DragDropDirective,
     MatDialogModule, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule ]
})
export class HeadersComponent implements OnInit {
@Output() spinnerConfig = new EventEmitter<boolean>(null);
  loggedInUserData;
  firmuseracctid;
  headersData: any = [];
  headerEditData: any = [];
  isHeaderEdit: boolean = false;
  headerSrc;
  bucketName: any;
  FirmheaderID;
  Header: any;
  headerName: any;
  headerNameCopy: string = '';
  JsonFilePath;
  s3signatureKey: any;
  signatureKeyResizeImage: any;
  imageFile: any;
  originalFile: any;
  originalFileName: any;
  deleteHeaderData: any = {};
  deleteHeaderConfirmationMessage: string = '';
  originalHeadersData: any = [];
  isHeadersAvailable: WritableSignal<boolean> = signal<boolean>(true);
  newHeader: WritableSignal<boolean> = signal<boolean>(false);
  originalFileNameWithoutExt: string;
  originalFileExtension: string;
  headersDataforSearch: WritableSignal<any[]> = signal<any[]>([]);
//  @ViewChild('headerImage') headerImage: any;
  @ViewChild('deleteheaderDialog') deleteHeaderDialog: TemplateRef<any>;
  @ViewChild("headerName") headerNameInput: ElementRef;
  useracctid: any;

  errorMessage: string;
  headersDataLoading: boolean = false;
  clickCustomEvent: any;
  private _searchTerm = signal('');
  @Input() set searchTerm(value: string) {
    this._searchTerm.set(value);
  }

  readonly filteredHeadersData = computed(() => {
    const term = this._searchTerm().toLowerCase().trim();
    return term.length >= 3
      ? this.headersDataforSearch().filter(item =>
        item.headername.toLowerCase().includes(term)
      )
      : this.headersDataforSearch();
  });

  constructor(private apiService: ApiService, private toastr: ToastrService, 
              private shareService: SharedService, public dialog: MatDialog, private encodingService: EncodingService,
              private cdr: ChangeDetectorRef, private fileService: FileService, private firmService: FirmService) { }

  ngOnInit() {
    this.loggedInUserData = JSON.parse((localStorage.getItem('userDetails')));
    this.bucketName = this.loggedInUserData.s3BucketName
    if (this.loggedInUserData && this.loggedInUserData.useracctid) {
      this.useracctid = this.loggedInUserData.useracctid
    }
    if (this.loggedInUserData && this.loggedInUserData.firmUserAcctId) {
      this.firmuseracctid = this.loggedInUserData.firmUserAcctId
    }
    this.s3signatureKey = 'Engagements/' + this.firmuseracctid + '_Firm/' + 'Templates/' + 'Common/' + 'Headers';
    this.signatureKeyResizeImage = "internal-data/" + this.firmuseracctid  + "-firm/components/resize/headers";
    this.getHeaders();
  }

  getHeaders(isSkip?: boolean, isChange:boolean=false) {
    this.isHeaderEdit = false;
    this.headerEditData = [];

    this.spinnerConfig.emit(true);
    this.headersDataLoading = true;
    this.fileService.getFirmHeaderAndFooter().pipe(finalize(() => this.spinnerConfig.emit(false))).subscribe({
      next: res => {
        if (res.status === 200) {
          let result = JSON.parse(res.data);
          if (result.headerdetails && result.headerdetails.length > 0) {
             this.headersData = result.headerdetails.map(h => ({
            ...h,
            s3JSONFilePath$: this.apiService.getFiles(h.JsonFilePath),
            resized_JsonFilePath$: h.resized_JsonFilePath
              ? this.apiService.getFiles(h.resized_JsonFilePath)
              : of(null)
          }));
            this.originalHeadersData = JSON.parse(JSON.stringify(result.headerdetails));
            this.isHeadersAvailable.set(true);
            this.newHeader.set(false);
            this.headersDataforSearch.set(this.headersData);

            const allIsUserSelectedZero = this.headersData.every(
              obj => obj.isuserselected === 0 || obj.isuserselected === null
            );

            if (allIsUserSelectedZero) {
              this.headersData[0].isuserselected = 0;
              this.saveHeaderSelection(this.headersData[0]);
            }
          } else {
            this.headersData = [];
            this.isHeadersAvailable.set(false);
            this.newHeader.set(false);
          }           
          this.headersDataLoading = false;
          if (isChange) {
            this.selectItem(0, this.headersData[0]);
          }
          this.cdr.detectChanges();
        }
      }, error(e) {
        this.toastr.error(e.error);
        this.headersDataLoading = false;
      }
    });
  }

  setFocus() {
    setTimeout(() => {
      this.headerNameInput.nativeElement.focus();
    }, 1);
  }

  uploadHeader(event, type) {
    let file: any = [];

    if (type === 'dnd') {
      file = event;
    } else {
      file = event.target.files;
    }
    if (this.isValidFileCheck(file[0])) {
      if (file && file.length > 0) {
        this.imageFile = file[0];
        this.originalFile = file[0];
        this.originalFileName = this.imageFile.name;
        this.originalFileNameWithoutExt = this.imageFile.name.split('.').slice(0, -1).join('.');
        this.originalFileExtension = this.imageFile.name.split('.').pop();

        // Check file size
        if (this.imageFile.size > 5 * 1024 * 1024) {
          this.toastr.error('<b>Error Uploading Header</b><br>Your image exceeded size limit for the header. Please check the specifications and try again.', null, {
            enableHtml: true,
          });
        } else {
          const fileReader: FileReader = new FileReader();
          fileReader.readAsDataURL(this.imageFile);

          fileReader.onload = (event: Event) => {
            var image = new Image();
            image.src = fileReader.result as string;

            image.onload = () => {
              var height = image.height;
              var width = image.width;
              var originalAspectRatio = width / height;

              // Check aspect ratio and dimensions
              if (width <= 720 && height <= 200) { // If This do nothing directly Upload the Headers-No Checks-Directly Save it.
                this.saveHeader();
              } else if (width >= 720) {
                if (originalAspectRatio < 3.6) {
                  this.toastr.error('<b>Uploaded image does not meet criteria.</b><br> Please read the instructions in the center section for format and size limits and attempt the upload again.', null, {
                    enableHtml: true
                  });
                  /* CPT-8809*/
                  this.spinnerConfig.emit(true);
                  this.newHeader.set(false);
                  this.cdr.detectChanges();
                  this.newHeader.set(true);
                  this.spinnerConfig.emit(false);
                  return;
                } else {
                  let targetWidth = 720;
                  let targetHeight = targetWidth / originalAspectRatio;
                  this.resizeImage(fileReader.result as string, targetWidth, targetHeight)
                    .then(resizedImage => {
                      this.imageFile = this.dataURItoBlob(resizedImage, this.originalFileName, this.originalFileExtension);
                      this.toastr.success('Image width has been resized to fit the header.');
                      this.saveHeader();
                    })
                    .catch(error => {
                      console.error('Error resizing image:', error);
                      this.toastr.error('Error resizing image.');
                    });
                }
              } else if (height >= 200) {
                if (originalAspectRatio < 3.6) {
                  this.toastr.error('<b>Uploaded image does not meet criteria.</b><br> Please read the instructions in the center section for format and size limits and attempt the upload again.', null, {
                    enableHtml: true
                  });
                  /* CPT-8809*/
                  this.spinnerConfig.emit(true);
                  this.newHeader.set(false);
                  this.cdr.detectChanges();
                  this.newHeader.set(true);
                  this.spinnerConfig.emit(false);
                  return;
                } else {
                  // console.log(originalAspectRatio, width, height);
                }
              }
            }
          }
        }
      }
    } else {
      this.toastr.error('Please upload a valid image file');
    }
  }

  resizeImage(imageSource: string, targetWidth: number, targetHeight: number): Promise<string> {
    return new Promise((resolve, reject) => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      canvas.width = targetWidth;
      canvas.height = targetHeight;

      const image = new Image();
      image.src = imageSource;

      image.onload = () => {
        ctx.drawImage(image, 0, 0, targetWidth, targetHeight);
        resolve(canvas.toDataURL('image/jpeg'));
      };

      image.onerror = (error) => {
        reject(error);
      };
    });
  }

  isValidFileCheck(file: any): boolean {
    let fileName = file.name.toLowerCase();
    return fileName.endsWith(".jpeg") || fileName.endsWith(".jpg") || fileName.endsWith(".png") || fileName.endsWith(".gif");
  }

  dataURItoBlob(dataURI: string, fileName: string, originalFileExtension: string): Blob {
    const byteString = atob(dataURI.split(',')[1]);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const uint8Array = new Uint8Array(arrayBuffer);

    for (let i = 0; i < byteString.length; i++) {
      uint8Array[i] = byteString.charCodeAt(i);
    }
    // Use the original file extension when creating the Blob
    const mimeType = `image/${originalFileExtension}`;
    return new Blob([arrayBuffer], { type: mimeType});
  }

  saveHeader() {
    let jsonFileName = this.originalFileName;
    let JsonFilePath = this.s3signatureKey + '/' + jsonFileName;
    let JsonFilePathResizedImage = this.signatureKeyResizeImage + '/' + jsonFileName;

    let obj = {
      "firmheader": {
        "headername": this.originalFileNameWithoutExt,
        "JsonFileName": jsonFileName,
        "JsonFilePath": JsonFilePath,
        "resized_JsonFilePath": JsonFilePathResizedImage,
        "isdelete": 0,
        "FirmheaderID": 0
      }
    };
    let dataJsonString = JSON.stringify(obj);
    this.spinnerConfig.emit(true);
    this.firmService.saveFirmHeader(dataJsonString).pipe(finalize(() => this.spinnerConfig.emit(false))).subscribe({
      next: res => {
        if (res.status === 200) {
          this.FirmheaderID = res.data;
          this.saveHeaderWithId();
          this.saveJson(jsonFileName);
        }
      }, error: e => {
        console.error('Error saving header:', e);
      }
    })
  }

  saveJson(jsonFileName) {
    let formData: FormData = new FormData();
    let filesArray = [this.originalFile, this.imageFile];
    for (let i = 0; i < filesArray.length; i++) {
      const fileName = i === 1 ? `${this.FirmheaderID}.${this.originalFileExtension}` : jsonFileName;
      formData.append('file', filesArray[i], fileName);
    }
    const uploadObj = JSON.stringify({
      "module": modules[15],
      "firmId": this.firmuseracctid,
      "status": 0,
      "folderName": "Headers",
      "appSyncId": this.loggedInUserData.useracctid,
      "extension": "temp"
    })
    formData.append('upload', this.encodingService.enData(uploadObj, "body"));
    this.spinnerConfig.emit(true);
    this.apiService.saveAndGetFileNamePath(formData).pipe(finalize(() =>this.spinnerConfig.emit(false))).subscribe(response => {
      this.getHeaders(true,true);
      this.toastr.success('Header added successfully');
      this.shareService.refreshHeaderFooter.next(true);
    }, error => {
      this.toastr.error(error.error);
    });
  }

  deleteHeaderConfirmation(data) {
    this.deleteHeaderData = data;

    if (data.isuserselected === 1) {
      this.deleteHeaderConfirmationMessage = 'You are trying to delete an already selected header. This will also be removed from the respective sections';
    } else {
      this.deleteHeaderConfirmationMessage = 'You are trying to delete a header.';
    }

    const dialogRef = this.dialog.open(this.deleteHeaderDialog, { disableClose: true });
    dialogRef.afterClosed().subscribe(result => {
      this.deleteHeaderData = {};
      this.deleteHeaderConfirmationMessage = '';
    });
  }

  deleteSelectedHeader() {
    let data = this.deleteHeaderData;
    let obj = {
      "firmheader": {
        "headername": data.headername,
        "JsonFileName": data.JsonFileName,
        "JsonFilePath": data.JsonFilePath,
        "isdelete": 1,
        "FirmheaderID": data.FirmheaderID ? data.FirmheaderID : 0
      }
    };

    let dataJsonString = JSON.stringify(obj);
    this.firmService.saveFirmHeader(dataJsonString).subscribe({
      next: res => {
        if (res.status === 200) {
          this.toastr.success('Header deleted successfully');
          this.getHeaders();
          this.cdr.detectChanges();
          this.shareService.refreshHeaderFooter.next(true);
        }
      }, error: e => {
        this.toastr.error(e.error);
      }
    })
  }

  saveHeaderName(data) {
    if (!data.headername || data.headername.trim() === '') {
      this.errorMessage = 'Please name your header';
      this.toastr.error(this.errorMessage);
      return;
    }
    // Check if headername already exists
    const headerExists = this.originalHeadersData.some(header => header.headername === data.headername);

    if (headerExists) {
      this.errorMessage = 'Header name already exists';
      return;
    }

    this.errorMessage = '';
    let obj = {
      "firmheader": {
        "headername": data.headername,
        "JsonFileName": data.JsonFileName,
        "JsonFilePath": data.JsonFilePath,
        "resized_JsonFilePath":data?.resized_JsonFilePath ? data?.resized_JsonFilePath : null,
        "isdelete": 0,
        "FirmheaderID": data.FirmheaderID ? data.FirmheaderID : 0
      }
    };

    let finalObj = JSON.stringify(obj);

    this.firmService.saveFirmHeader(finalObj).subscribe({
      next: res => {
        if (res.status === 200) {
          this.getHeaders();
          this.toastr.success('Header renamed successfully');
        }
      }, error: e => {
        this.toastr.error(e.error);
      }
    })
  }

  saveHeaderSelection(value) {
    const userSelectedHeaderModel: UserSelectedHeaderModel = {
      headerId: value.FirmheaderID,
      footerId: 0,
      isUserSelected: value.isuserselected === 0 ? 1 : (value.isuserselected === 1 ? 0 : 1)
    }
    this.firmService.saveUserSelectedFirmHeader(userSelectedHeaderModel).subscribe({
      next: res => {
        if (res.status === 200 && res.data) {
          this.toastr.success('Header selected successfully');
          this.getHeaders();
          this.cdr.detectChanges();
        }
      }, error: e => {
        this.toastr.error(e.error);
      }
    })
  }

  validateUnsavedChanges(data, type) {
    this.errorMessage = '';
      if (type === 'edit') {
        this.editHeader(data);
        this.setFocus();
      } else if (type === 'delete') {
        this.deleteHeaderConfirmation(data);
      } else if (type === 'selection') {
        this.saveHeaderSelection(data);
      }
  }

  editHeader(data) {
    data.isHeaderEdit = true;
    this.headerNameCopy = data.headername;
    this.headerEditData = data;
    this.isHeaderEdit = true;
  }

  closeHeader(data) {
    data.isHeaderEdit = false;
    data.headername = this.headerNameCopy;
    this.isHeaderEdit = false;
    this.headerEditData = [];
    this.errorMessage = '';
  }

  saveUnsavedChanges() {
    this.saveHeaderName(this.headerEditData);
  }

  cancelUnsavedChanges() {
    let isExcludedButton = false;
    if (this.clickCustomEvent && this.clickCustomEvent.relatedTarget) {
      const relatedElement = this.clickCustomEvent.relatedTarget;
      isExcludedButton =
        relatedElement instanceof HTMLElement &&
        relatedElement.tagName === 'BUTTON' &&
        relatedElement.classList.contains('my-custom-setting');
      if (relatedElement instanceof HTMLElement) {
        relatedElement.click();
      }
    }
    if (!isExcludedButton) {
      this.getHeaders();
    }
  }

  // onSearch(text: string) {
  //   if (text.length > 2 || text.length < 3) {
  //     this.filterHeaders(text);
  //   } else {
  //     // Clear the search (assuming headersData is the original data)
  //     this.headersData = this.headersDataforSearch;
  //   }
  // }

  // filterHeaders(text: string) {
  //   if (text) {
  //     this.headersData = this.headersDataforSearch.filter(item =>
  //       item.headername.toLowerCase().includes(text.toLowerCase())
  //     );
  //   } else {
  //     this.headersData = this.headersDataforSearch;
  //   }
  // }

  onAddClick(){
    this.newHeader.set(true);
  }
  onCheckboxChange(event,data){
    data.is_stretch_fit = event.checked ? 1 : 0;
    let obj = {
      "firmheader": {
        "headername": data.headername,
        "JsonFileName": data.JsonFileName,
        "JsonFilePath": data.JsonFilePath,
        "resized_JsonFilePath":data?.resized_JsonFilePath ? data?.resized_JsonFilePath : null,
        "isdelete": 0,
        "FirmheaderID": data.FirmheaderID ? data.FirmheaderID : 0,
        "is_stretch_fit": data.is_stretch_fit,
        "picture_alignment": data.picture_alignment
      }
    };

    let finalObj = JSON.stringify(obj);

    this.firmService.saveFirmHeader(finalObj).subscribe({
      next: res => {
        if (res.status === 200) {
          this.getHeaders();
          let message = event.checked ? 'Header stretched to fill successfully' : 'Header stretched to fill reverted successfully';
          this.toastr.success(message);
        }
      }, error: e => {
        this.toastr.error(e.error);
      }
    })
  }

  changeAlignment(data,alignment){
    data.picture_alignment = alignment;
    let obj = {
      "firmheader": {
        "headername": data.headername,
        "JsonFileName": data.JsonFileName,
        "JsonFilePath": data.JsonFilePath,
        "resized_JsonFilePath":data?.resized_JsonFilePath ? data?.resized_JsonFilePath : null,
        "isdelete": 0,
        "FirmheaderID": data.FirmheaderID ? data.FirmheaderID : 0,
        "is_stretch_fit": data.is_stretch_fit,
        "picture_alignment": data.picture_alignment
      }
    };

    let finalObj = JSON.stringify(obj);

    this.firmService.saveFirmHeader(finalObj).subscribe({
      next: res => {
        if (res.status === 200) {
          this.getHeaders(true, false);
          this.toastr.success(`Header ${alignment} alignment completed successfully`);
        }
      }, error: e => {
        this.toastr.error(e.error);
      }
    })
  }

  selectedItem: number | null = null;
  selectItem(index: number, header): void {
    this.selectedItem = index;
    this.shareService.changeHeaderSelection.next(header);
  }

  saveHeaderWithId() {
    let jsonFileName = this.originalFileName;
    let JsonFilePath = this.s3signatureKey + '/' + jsonFileName;
    let JsonFilePathResizedImage = this.signatureKeyResizeImage + '/' + this.FirmheaderID +'.'+this.originalFileExtension;

    let obj = {
      "firmheader": {
        "FirmUseraccountid": this.firmuseracctid,
        "headername": this.originalFileNameWithoutExt,
        "JsonFileName": jsonFileName,
        "JsonFilePath": JsonFilePath,
        "resized_JsonFilePath": JsonFilePathResizedImage,
        "isdelete": 0,
        "FirmheaderID": this.FirmheaderID
      }
    };
    let dataJsonString = JSON.stringify(obj);
    this.spinnerConfig.emit(true);
    this.firmService.saveFirmHeader(dataJsonString).pipe(finalize(() => this.spinnerConfig.emit(false))).subscribe({
      next: res => {
        if (res.status === 200) {
          this.FirmheaderID = res.data;
        }
      }, error: e => {
        console.error('Error saving header:', e);
      }
    })
  }

  getFormattedName(name: string): string {
    return name.length <= 16 ? name : name.slice(0, 16) + '...';
  }

  onHeaderBlur(event:any, buttonSection:HTMLElement, data:any){
    this.clickCustomEvent = event;
    const isChanged = this.originalHeadersData.some(header => {
      return data.FirmheaderID === header.FirmheaderID && header.headername !== data.headername;
    });
    const isSaveButton = event?.relatedTarget?.parentElement === buttonSection;
    if (!isSaveButton && isChanged) {
      setTimeout(() => {
        const dialogRef = this.dialog.open(UnsavedChangesDialogComponent,{
          restoreFocus : false
        });
        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            this.cancelUnsavedChanges();
          } else {
            this.saveUnsavedChanges();
          }
        });
      }, 100);

    }
  }

  closeNewheader() {
    this.newHeader.set(false);
  }
}
